export const Endpoints = {
    users: '/tusers',
    categories: '/categories',
    forms: '/forms',
    reActivation: '/users/re-activation',
    lockedUsers: '/users/locked',
    applicationAuditTrail: '/applications/:id/audit-trail',
    applicationAuditTrailExport: '/applications/:id/audit-trail/export',
    applicationsExport: '/applications/export',
    userApplicationsExport: '/applications/user/:id/export',
    usersExport: '/users/export',
    userExport: '/users/:userId/export',
}